var React = require('react');

function Quotes (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.98475 5.75898C9.59463 5.06932 8.64089 4.7788 7.90147 5.18792C4.59297 7.01851 3 9.62733 3 12.879C3 16.0845 4.41523 18 7.15725 18C9.10319 18 10.5627 16.7491 10.5627 14.7945C10.5627 13.0353 9.01474 11.9407 7.15725 11.9407C7.02457 11.9407 6.84767 11.9407 6.71499 11.9798C6.71499 10.0815 7.58407 8.77215 9.32223 7.72013C10.0463 7.28191 10.3772 6.45275 9.98475 5.75898ZM20.4663 5.75899C20.0762 5.06932 19.1226 4.7789 18.3826 5.18725C15.0653 7.01788 13.4373 9.62694 13.4373 12.879C13.4373 16.0845 14.8968 18 17.6388 18C19.5848 18 21 16.7491 21 14.7945C21 13.0353 19.4963 11.9407 17.6388 11.9407C17.5061 11.9407 17.3292 11.9407 17.1966 11.9798C17.1966 10.0815 18.0656 8.77215 19.8038 7.72013C20.5279 7.28191 20.8588 6.45275 20.4663 5.75899Z","fill":"currentColor"}));
}

Quotes.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Quotes;

Quotes.default = Quotes;
